export const DEFAULT_PRODUCT_QUANTITY_MAX_IN_CART = 99
